<template>
  <PageWrapper type="forgot">
    <FormLogo slot="logo" />

    <FormPasswordReset slot="passwordReset" />

    <PageContent slot="content" />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/login/PageWrapper.vue'
import PageContent from '@/components/login/PageContent.vue'
import FormLogo from '@/components/login/FormLogo.vue'
import FormPasswordReset from '@/components/login/FormPasswordReset.vue'

export default {
  name: 'PasswordReset',
  components: {
    PageWrapper,
    PageContent,
    FormLogo,
    FormPasswordReset
  }
}
</script>
